import React, {useEffect, useState} from 'react';
import GTM from './gtm_code';

const GtmComponent = ({callbackLoaded}) => {
  const [gtmLoaded, setGtmLoaded] = useState(false);

  useEffect(() => {
    const controlCache = sessionStorage.getItem('gtmWasLoaded');
    if (!gtmLoaded) {
        setTimeout(() => {
            import("./gtm_code").then(
                (module) => {
                    sessionStorage.setItem('gtmWasLoaded', true);
                    setGtmLoaded(() => module.default);
                    setGtmLoaded(true);
                    if(callbackLoaded){
                      callbackLoaded();
                    }
                }
            );
        }, controlCache ? 0 : 3000);
    }
}, [gtmLoaded])

  return (
    <>
      {
        gtmLoaded && <GTM />
      }
    </>
  );
};

export default GtmComponent;
